export const hasSlateAstOperations = (operations) =>
  operations.some((op) => 'set_selection' !== op.type);

export const slateEditorHasContent = (editor) =>
  Array.isArray(editor.children) && editor.children.length > 0;
